import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'

import {
  getUser,
  setOrganizationDetails,
  setStep,
  setUserInformations,
} from '../state'
import { Form } from '../../../../components'
import { EmailInput } from '../../../../components/Forms/Email'
import { useCreateEmailVerificationCodeMutation } from '../../../../remote/graphql'
import { CreateSteps } from '../CreateSteps'
import { useIntl } from 'react-intl'

type EmailForm = {
  email: string
}

export function EmailFormLayout({ superEnabled }: { superEnabled: boolean }) {
  const intl = useIntl()
  const { email, cacheKey } = useSelector(getUser)
  const dispatch = useDispatch()

  const { handleSubmit, control, setError } = useForm<EmailForm>({
    defaultValues: { email: email ?? '' },
    mode: 'onSubmit',
  })

  const [createEmailVerificationCode, { loading }] =
    useCreateEmailVerificationCodeMutation({
      onCompleted: (data) => {
        const { displayName, organizationName, isPopularDomain, domain } =
          data.createEmailVerificationCode
        dispatch(setUserInformations({ displayName }, false))
        dispatch(
          setOrganizationDetails(
            { isPopularDomain, name: organizationName, domain },
            false
          )
        )
        const nextStep = cacheKey
          ? CreateSteps.CredentialsSubmitted // With SSO
          : CreateSteps.EmailVerification
        dispatch(setStep(nextStep))
      },
      onError: (error) =>
        setError('email', { message: error.message, type: 'server' }),
    })

  const onSubmit = (data: EmailForm) => {
    dispatch(setUserInformations({ email: data.email }, false))
    createEmailVerificationCode({
      variables: { input: { email: data.email, fromSuper: superEnabled } },
    })
  }

  return (
    <>
      <form
        className="flexbox flexbox-column"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <EmailInput<EmailForm>
          name="email"
          control={control}
          className="radius-large"
        />
        <Form.Button disabled={loading}>
          {intl.formatMessage({
            id: 'boarding.org.create.start.continueWithEmail',
            defaultMessage: 'Continue with email',
          })}
        </Form.Button>
      </form>
    </>
  )
}
